import { useQueryClient } from '@tanstack/react-query';
// Export query key helpers for use in other repositories
export function getCollectionListQueryKey(props) {
    return ['research', 'collection', 'find', props];
}
export function getCollectionLookupQueryKey(props) {
    return ['research', 'collection', 'lookup', props];
}
export function createCollectionRepository(config) {
    const { repository, client } = config;
    return {
        usePrefetchRetrieve(context) {
            const queryClient = useQueryClient();
            return {
                trigger(props) {
                    return queryClient.prefetchQuery({
                        queryKey: getCollectionLookupQueryKey(props),
                        async queryFn() {
                            const response = await client.user.default.collectionRetrieve(props);
                            return response.data;
                        },
                    });
                },
            };
        },
        useFind(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: getCollectionListQueryKey(props),
                async queryFn() {
                    const { data: { data: collections }, } = await client.user.default.collectionList(props);
                    return collections;
                },
            });
            return query;
        },
        useLookup(context, props, options) {
            const query = repository.useQuery({
                ...options,
                queryKey: getCollectionLookupQueryKey(props),
                async queryFn() {
                    const { data: collection } = await client.user.default.collectionRetrieve(props);
                    return collection;
                },
            });
            return query;
        },
    };
}
//# sourceMappingURL=collectionRepository.js.map